<template>
  <div id="app">
    <div v-if="unsupportedBrowser">
      Unsupported browser!
    </div>
    <template v-else>
      <div id="dropzone" ref="dropzone" style="visibility:hidden;opacity:0">
        <div id="textnode">
          Drop file to convert
        </div>
      </div>

      <h3 class="mb-10 text-center text-grey-dark">
        BzChannel Statement CSV Convertor
      </h3>

      <div class="mb-5 pt-10 flex items-center justify-center">
        <label
          for="upload"
          class="bg-teal-light cursor-pointer border-2 border-purple-lightest pt-10 pb-4 px-5 rounded-lg shadow-lg"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            class="opacity-75"
          >
            <g transform="translate(0 0)">
              <g class="nc-icon-wrapper" fill="#000000">
                <path
                  fill="#fff"
                  d="M46,10H24.5l-5.701-7.6C18.611,2.148,18.314,2,18,2H2C1.448,2,1,2.448,1,3v39c0,2.209,1.791,4,4,4h38 c2.209,0,4-1.791,4-4V11C47,10.448,46.552,10,46,10z M31.707,26.707C31.512,26.902,31.256,27,31,27s-0.512-0.098-0.707-0.293 L25,21.414V37c0,0.553-0.447,1-1,1s-1-0.447-1-1V21.414l-5.293,5.293c-0.391,0.391-1.023,0.391-1.414,0s-0.391-1.023,0-1.414 l6.999-6.999c0.092-0.093,0.203-0.166,0.326-0.217c0.244-0.101,0.519-0.101,0.764,0c0.123,0.051,0.234,0.125,0.327,0.217 l6.999,6.999C32.098,25.684,32.098,26.316,31.707,26.707z"
                />
              </g>
            </g>
          </svg>
          <p class="text-white text-sm font-bold leading-loose">
            Drop CSV file or click to select
          </p>
          <input
            id="upload"
            ref="fileInput"
            class="bg-grey outline-none hidden"
            type="file"
            @change="fileAdded"
          >
        </label>
      </div>

      <div
        v-if="errors && errors.length > 0"
        class="mt-10 w-full flex flex-col items-center justify-center"
      >
        <p class="text-red-light mb-2 text-bold">
          Lines not converted
        </p>
        <div class="bg-black text-white shadow-lg p-5 max-w-sm">
          <ol class="list-reset text-xs">
            <li
              v-for="(error, index) in errors"
              :key="index + 1"
              class="text-left leading-tight"
            >
              {{ error }}
            </li>
          </ol>
        </div>
      </div>

      <div class="fixed pin-b pin-x mb-6 text-xs font-medium text-grey-dark">
        &copy;2019 {{ copyright }}. All rights reserved.<br>
        <span
          class="leading-loose"
          style="font-size:11px;"
        >&#x2768; version {{ version }} &#x2769;</span>
      </div>
    </template>
  </div>
</template>

<script>
import { saveAs } from 'file-saver'
import * as Papa from 'papaparse'

// const VALID_COLUMNS = 18
export default {
  name: 'App',
  data() {
    return {
      unsupportedBrowser: false,
      file: null,
      errors: [],
      dropzoneStyle: { visibility: 'hidden', opacity: 0 },
      accountNo: '',

      copyright: 'Iconix Systems & Solutions Sdn Bhd',
      version: '1.0.0'
    }
  },
  mounted() {
    if (typeof FileReader === 'undefined') {
      this.unsupportedBrowser = true
      return
    }
    const self = this
    window.addEventListener('dragenter', function() {
      document.querySelector('#dropzone').style.visibility = ''
      document.querySelector('#dropzone').style.opacity = 1
      document.querySelector('#textnode').style.fontSize = '48px'
    })

    window.addEventListener('dragleave', function(e) {
      e.preventDefault()

      document.querySelector('#dropzone').style.visibility = 'hidden'
      document.querySelector('#dropzone').style.opacity = 0
      document.querySelector('#textnode').style.fontSize = '42px'
    })

    window.addEventListener('dragover', function(e) {
      e.preventDefault()
      document.querySelector('#dropzone').style.visibility = ''
      document.querySelector('#dropzone').style.opacity = 1
      document.querySelector('#textnode').style.fontSize = '48px'
    })

    window.addEventListener('drop', function(e) {
      e.preventDefault()
      document.querySelector('#dropzone').style.visibility = 'hidden'
      document.querySelector('#dropzone').style.opacity = 0
      document.querySelector('#textnode').style.fontSize = '42px'

      self.init(e.dataTransfer.files[0])
      self.convertFile()
    })
  },
  methods: {
    init(file) {
      this.file = file
      this.errors = []
    },
    fileAdded() {
      this.init(this.$refs.fileInput.files[0])
      this.convertFile()
    },
    formatLine(line, data, header) {
      // empty line
      if (!data[1]) return false

      // ignore Debit line
      if (data[8] === 'D' || data[8] === 'd') return false

      const trxAmount = isNaN(parseFloat(data[7])) ? data[7] : parseFloat(Math.round(data[7] * 100.0) / 100.0).toFixed(2)

      const acctNo = data[0]
      const trxCode = header ? 'Trx Code' : data[4]
      const trxType = header ? 'Trx Type' : data[8]
      const trxDate = data[2] ? data[2].replace(/(\d{1,2})(\d{2})(\d{4})/, '$3-$2-$1') : data[2]
      const trxTime = data[11] ? data[11].replace(/(\d{1,2})(\d{2})(\d{2})/, '$1:$2:$3') : data[11]
      const docRefNo = data[6]
      const custRefNo = data[12].replace(/,/g, '')
      const recipientRef = data[15].replace(/,/g, '')
      const otherDetails = data[16].replace(/,/g, '')
      const senderName = data[17].replace(/,/g, '')
      const invNo = header ? 'Matched Invoice #' : ''

      return `${acctNo},${trxCode},${trxType},${trxDate},${trxTime},${trxAmount},${docRefNo},${custRefNo},${recipientRef},${otherDetails},${senderName},${invNo}`
    },
    convertFile() {
      const regex = /^([a-zA-Z0-9\s_\\.\-:])+(.csv)$/
      if (regex.test(this.file.name.toLowerCase())) {
        const reader = new FileReader()
        reader.onload = e => {
          const outputs = []

          // const rows = e.target.result.split('\n')

          const parsed = Papa.parse(e.target.result)
          const rows = parsed.data

          // skip first 5 rows - unwanted info rows
          const START = 6
          for (let i = START; i < rows.length; i++) {
            // const cells = rows[i].split(',')

            // if (cells.length !== VALID_COLUMNS) {
            //   if (cells.length > 1) {
            //     this.errors.push(
            //       `Invalid line format @ ${i}: ${JSON.stringify(cells)}`
            //     )
            //   }
            //   continue
            // }

            // const converted = this.formatLine(i, cells, i === START)

            const converted = this.formatLine(i, rows[i], i === START)

            if (converted !== false) outputs.push(converted)
          }

          const blob = new Blob([outputs.join('\n')], {
            type: 'text/plain;charset=utf-8'
          })
          saveAs(blob, 'Statement.csv')
        }

        reader.readAsText(this.file)
      } else {
        alert('Please upload a valid CSV file.')
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
div#dropzone {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: visibility 175ms, opacity 175ms;
  display: table;
  text-shadow: 1px 1px 2px #000;
  color: #fff;
  background: rgba(0, 0, 0, 0.45);
  font: bold 42px Oswald, DejaVu Sans, Tahoma, sans-serif;
}

div#textnode {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  transition: font-size 175ms;
}
</style>
